import 'glider-js';
import 'alpinejs'

import LazyLoad from "vanilla-lazyload";
const Intercom = require('./components/intercom');



window.onload = function () {

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
        // ... more custom settings?
    });

    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

    if (!isMobile) {

        Intercom.init();




    }
}
/*
jQuery(function ($) {

    $(document).ready(function () {




    });
}); */